var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @packageDocumentation
 * @module API
*/
import axios from 'axios';
import qs from 'qs';
import hash from 'object-hash';
import { Logger } from '../browserBased';
/**
 * Class that handles the requests through axios library
 */
var APIRequest = /** @class */ (function () {
    function APIRequest() {
        var _this = this;
        /**
         * Variable to store the requests in progress
         */
        this.requestsCancel = {};
        /**
         * Function that cancel a particular requestId with an optional custom message
         * @param props from CancelRequestProps
         */
        this.cancelRequest = function (props) {
            var requestId = props.requestId, message = props.message;
            _this.requestsCancel[requestId].cancelSource.cancel(message || 'Cancelled request by the user');
        };
        /** check the request to decide what to do before making the request
         * POSSIBLE OUTCOMES:
         *     Return the axiosPromise related to the same request/hash
         *     Cancel the old request and return undefined to create a new one
         *     Return undefined which means, create a new request
         * @param props from MakeRequestProps
         */
        this.manageRequest = function (props) {
            var data = props.data, requestId = props.requestId, params = props.params;
            var hashedData = hash(__assign(__assign({}, params), data));
            // if there is a request with same id already in progress
            if (Object.keys(_this.requestsCancel).indexOf(requestId) !== -1) {
                // check if the hash of the data is the same that we have, if so return the same promise we are waiting for
                if (_this.requestsCancel[requestId].hash === hashedData) {
                    return _this.requestsCancel[requestId].axiosPromise;
                }
                // if the hash is different then cancel the old request and return null
                _this.cancelRequest({ requestId: requestId });
                return undefined;
            }
            // if it's not the same requestId then return null
            return undefined;
        };
        /**
         *  Function to make the actual call using axios and returning a promise
         * @param props from MakeRequestProps
         */
        // eslint-disable-next-line complexity
        this.makeRequest = function (props) {
            var url = props.url, method = props.method, headers = props.headers, data = props.data, params = props.params, requestId = props.requestId;
            var headersToSend = headers || {};
            var hashedData = hash(__assign(__assign({}, params), data));
            var theRequestId = requestId || hashedData;
            // analysis of the request and return the action to do
            var requestPromise = _this.manageRequest(__assign(__assign({}, props), { requestId: theRequestId }));
            // if the request is defined, return the promise
            if (requestPromise)
                return requestPromise;
            _this.requestsCancel[theRequestId] = {
                hash: hashedData,
                cancelSource: axios.CancelToken.source(),
            };
            // if we don't have headers content-type, set default
            if ((headersToSend && !headersToSend['Content-Type']) || !headersToSend) {
                headersToSend['Content-Type'] = 'application/json';
                headersToSend.Accept = 'application/json';
            }
            // build the config for axios call
            var baseConfig = {
                url: url,
                method: method,
                headers: headersToSend,
                cancelToken: _this.requestsCancel[theRequestId].cancelSource.token,
                params: params,
                data: data,
            };
            _this.requestsCancel[theRequestId].axiosPromise = axios.request(baseConfig)
                .then(function (response) {
                delete _this.requestsCancel[requestId];
                return response;
            }).catch(function (error) {
                if (axios.isCancel(error)) {
                    Logger.info("Request canceled " + error.message);
                    return null;
                }
                Logger.error("Error when calling the endpoint " + error);
                return error;
            });
            return _this.requestsCancel[theRequestId].axiosPromise;
        };
        /**
         * Function to do a GET thru axios
         * @param props from MakeRequestProps
         */
        this.get = function (props) { return _this.makeRequest(__assign(__assign({}, props), { method: 'GET' })); };
        /**
         * Function to do a POST thru axios
         * @param props from MakeRequestProps
         */
        this.post = function (props) { return _this.makeRequest(__assign(__assign({}, props), { method: 'POST' })); };
        /**
         * Function to do a PUT thru axios
         * @param props from MakeRequestProps
         */
        this.put = function (props) {
            var headers = {
                'Content-Type': 'application/merge-patch+json',
                Accept: 'application/merge-patch+json',
            };
            return _this.makeRequest(__assign(__assign({}, props), { headers: headers, method: 'PUT' }));
        };
        /**
         * Function to do a PATCH thru axios
         * @param props from MakeRequestProps
         */
        this.patch = function (props) {
            var headers = {
                'Content-Type': 'application/merge-patch+json',
                Accept: 'application/merge-patch+json',
            };
            return _this.makeRequest(__assign(__assign({}, props), { headers: headers, method: 'PATCH' }));
        };
        /**
         * Function to do encode the data and do a POST thru axios
         * @param props from MakeRequestProps
         */
        this.postURLEncoded = function (props) {
            var headers = {
                'Content-type': 'application/x-www-form-urlencoded',
                Accept: 'application/x-www-form-urlencoded',
            };
            var dataEncoded = qs.stringify(props.data);
            return _this.post(__assign(__assign({}, props), { headers: headers, data: dataEncoded }));
        };
    }
    return APIRequest;
}());
export default new APIRequest();
//# sourceMappingURL=request.js.map